import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled, View, H2 } from "dripsy";
var SectionContainer = styled(View)({
    marginTop: "$04",
    gap: "$02"
});
var SectionTitle = styled(H2, {
    defaultVariant: "text.primary"
})();
export function Section(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ _jsxs(SectionContainer, {
        children: [
            title ? /*#__PURE__*/ _jsx(SectionTitle, {
                children: title
            }) : null,
            children
        ]
    });
}
